(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('OrganoRelevanteDeleteController',OrganoRelevanteDeleteController);

    OrganoRelevanteDeleteController.$inject = ['$uibModalInstance', 'entity', 'OrganoRelevante'];

    function OrganoRelevanteDeleteController($uibModalInstance, entity, OrganoRelevante) {
        var vm = this;

        vm.organoRelevante = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OrganoRelevante.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
